export default {
    global: {
        units: {
            thousand: 'tis.',
            million: 'mil.',
            billion: 'mld.',
            trillion: 'bil.',
        },
        currency: {
            czk: 'Kč',
            eur: '€',
            points: '{points} bodov',
        },
        days: {
            today: 'Dnes',
            tomorrow: 'Zajtra',
        },
    },
    header: {
        menuContent: {
            movies: 'Filmy',
            cinestarClub: 'CineStar Club',
            events: 'Akce',
        },
        chooseCinemaContent: {
            title: 'Potvrďte predvybrané kino alebo zvoľte iné',
        },
        shoppingCart: {
            tickets: '{count, plural, one {Vstupenka} few {Vstupenky} other {Vstupeniek}}',
            minutes: '{count, plural, one {Minúta} few {Minúty} other {Minút}}',
        },
    },
    orderSteps: {
        first: 'Výber miesta',
        second: 'Vaša objednávka',
        third: 'Kontaktné údaje',
        fourth: 'Zhrnutie <span>objednávky</span> a platba',
        fourthRes: 'Zhrnutie <span>rezervácie</span> a potvrdenie',
    },
    userProfile: {
        title: 'Staň sa členom {br}Cinestar Klubu',
        description: 'Získaj zľavu 20 Kč za každú vstupenku, zbieraj body za tvoju spotrebu a vyber si odmeny zadarmo.',
        buttonOrder: 'OBJEDNAJ ČLENSTVO ONLINE',
        cardValidity: 'Vaše členstvo vyprší',
        menuBar: {
            ticketAndReservation: 'Vstupenky a rezervácie',
            cinestarClub: 'Cinestar Club',
            lostCard: 'Strata karty',
            contactInfo: 'Kontaktné údaje',
            passChange: 'Zmena hesla',
        },
        ticketsAndReserv: {
            title: 'Vstupenky a rezervácie',
            ticket: 'Vstupenka',
            tickets: 'Vstupenky',
            orderNumber: 'číslo objednávky',
            reservationNumber: 'číslo rezervácie',
        },
        cinestarClub: {
            title: 'Cinestar Club',
            clubNachos: 'Klubové nachos menu zadarmo',
            missingPoints: 'K získaniu potrebujete ešte {points} bodov.',
            coupons: {
                title: 'Kupóny',
                noCoupons: 'Nemáte žiadne kupóny',
            },
            rewards: {
                title: 'Odmeny',
                noRewards: 'Nemáte žiadne odmeny',
            },
            pointsOverview: {
                title: 'Prehľad bodov',
                currentStatus: 'Aktuálny stav',
                date: 'Dátum',
                purchase: 'Nákup',
                points: 'Body',
                loadMore: 'Načítať dalšie',
            },
        },
    },
    hall: {
        hallHeader: {
            changeTime: 'Zmeniť čas',
            dateAndVenue: '{date}, {venue}',
            hallPicture: 'Foto sálu',
            'gold-class': {
                title: 'GOLD CLASS',
                description: 'GOLD CLASS description',
            },
            deluxe: {
                title: 'THEATRE DELUXE',
                description: 'THEATRE DELUXE description',
            },
            subtitles: 'Titulky',
        },
        legend: {
            title: 'Legenda',
            zoom: 'Zväčšit',
            move: 'Posunúť',
            seat: {
                classic: {
                    single: 'Klasické sedadlo',
                    double: 'Dvojsedadlo',
                },
                vip: {
                    single: 'VIP sedadlo',
                    double: 'VIP dvojsedadlo',
                },
                gold: {
                    single: 'Gold sedadlo',
                    double: 'Gold dvojsedadlo',
                },
                deluxe: {
                    single: 'Deluxe sedadlo',
                    double: 'Deluxe dvojsedadlo',
                },
                wheelchair: {
                    single: 'Miesto pre vozíčkarov',
                    double: 'Miesto pre vozíčkarov',
                },
                positionable: {
                    single: 'Polohovateľné',
                    double: 'Polohovateľné',
                },
                selected: {
                    single: 'Vybrané',
                    double: 'Vybrané',
                },
                reserved: {
                    single: 'Obsadené',
                    double: 'Obsadené',
                },
            },
            seatDescription: {
                material: 'Materiál',
                width: 'Šírka',
                classic: {
                    single: 'seatDescription Klasické sedadlo',
                    double: 'seatDescription Dvojsedadlo',
                    material: 'classic material',
                    singleWidth: '50cm',
                    doubleWidth: '100cm',
                },
                vip: {
                    single: 'seatDescription VIP sedadlo',
                    double: 'seatDescription VIP dvojsedadlo',
                    material: 'vip material',
                    singleWidth: '50cm',
                    doubleWidth: '100cm',
                },
                gold: {
                    single: 'seatDescription GOLD sedadlo',
                    double: 'seatDescription GOLD dvojsedadlo',
                    material: 'gold material',
                    singleWidth: '50cm',
                    doubleWidth: '100cm',
                },
                deluxe: {
                    single: 'seatDescription DELUXE sedadlo',
                    double: 'seatDescription DELUXE dvojsedadlo',
                    material: 'deluxe material',
                    singleWidth: '50cm',
                    doubleWidth: '100cm',
                },
                wheelchair: {
                    single: 'seatDescription Místo pro vozíčkáře',
                    double: 'seatDescription Místo pro vozíčkáře',
                    material: 'wheelchair material',
                    singleWidth: '50cm',
                    doubleWidth: '100cm',
                },
                positionable: {
                    single: 'seatDescription Polohovatelné',
                    double: 'seatDescription Polohovatelné',
                    material: 'positionable material',
                    singleWidth: '50cm',
                    doubleWidth: '100cm',
                },
            },
        },
        screen: 'Plátno',
    },
    basket: {
        btn: 'Pokračovať',
        selectedSeats: 'Vybrané sedadlá',
        totalPrice: 'Celková cena',
        totalPriceReservation: 'Celková cena rezervácie',
        textOnlineReservation: 'pri platbe online, na kiosku alebo v aplikácii',
        textCashReservation: 'Cena pri platbe na pokladne',
        reserveText: 'Cena pri uhradení rezervácie na pokladne  +{amount} {currency}',
        reserveBtn: 'Pokračovat <span>k rezervácii</span>',
        buyBtn: 'Pokračovať k nákupu',
        paymentBtn: 'Zaplatiť',
        reservationBtn: 'Rezervovať',
    },
    yourOrder: {
        nextFilm: 'Další film',
        tickets: {
            title: 'Vyberte typ vstupenky',
        },
        addTickets: {
            title: 'Pridajte vstupenky na daľší film',
            text: 'Pridať vstupenky',
        },
        addSnackCoupon: 'Pridajte kupón na občerstvenie',
        throwAway: 'Zahodiť?',
    },
    contactInfo: {
        haveAccount: 'Mám účet',
        withoutLogin: 'Bez prihlásenia',
        buyWithoutLogin: 'Nakúpim bez prihlásenia',
    },
    orderSummary: {
        ticketsDescription: {
            seat: 'Sedadlo',
            type: 'Typ',
            price: 'Cena',
            paymentPoints: 'Body platby',
            totalPrice: 'Celková cena objednávky',
            totalAmount: '{amount} Kč',
            maxTicketsLine: 'Klubovú zlavu ide uplatnit maximálne na 4 vstupenky',
            extendMembershipLine: 'Členstvo v CineStar Clube na 1 rok',
        },
        haveAvailable: 'Máte k dispozícii',
        getSale: 'Získajte zľavu 20 Kč na každú vstupenku.',
        giftVoucher: {
            title: 'Vymeniť darčekový poukaz',
            info: 'Môže byť zadávaný opakovane',
            byPhoto: 'Fotografovať / nahrať kód',
            byHand: 'Zadať ručne',
            number: 'Číslo poukazu',
        },
        paymentMethod: 'Vyberte, ako chcete zaplatit',
        downloadAppTitle: 'Zaplaťte v aplikácii, alebo na Kiosku a ušetrite 110 Kč.',
        downloadAppDesc:
            'V prípade zaplatenia rezervácie na kiosku alebo v mobilnej aplikácii vám bude na rozdiel od platby na pokladni účtovaná dodatočná zľava 110 Kč za platbu online.',
    },
    forms: {
        register: {
            title: 'Registrácia',
            orFillText: 'Alebo vyplňte',
            nameLabel: 'Meno',
            namePlaceholder: 'Meno',
            nameError: 'meno chyba',
            surnameLabel: 'Priezvisko',
            surnamePlaceholder: 'Priezvisko',
            surnameError: 'priezvisko chyba',
            phoneLabel: 'Telefón',
            phonePlaceholder: '789 123 456',
            phoneError: 'Telefónne číslo musí zodpovedať formátu 123456789 alebo 123 456 789',
            emailLabel: 'E-Mail',
            emailPlaceholder: 'E-Mail',
            emailError: 'Zadaný e-mail není platný',
            passwordLabel: 'Heslo',
            passwordPlaceholder: 'Zadajte vaše heslo',
            passwordError: 'heslo chyba',
            passwordConfLabel: 'Heslo znova',
            passwordConfPlaceholder: 'Pre kontrolu',
            passwordConfError: 'potvrdenie hesla chyba',
            passwordMatchesEmail: 'Heslo sa nesmie zhodovať s e-mailovou adresou',
            passwordsMustMatch: 'Heslá sa musia zhodovať',
            checkboxLabel: 'Súhlasím s Všeobecnými obchodnými podmienkami',
            checkBoxNotChecked: 'Musíte súhlasiť so Všeobecnými obchodnými podmienkami',
            buttonCreateMemberAccount: 'STAŤ SA ČLENOM CINESTAR CLUBU',
            buttonCreateBasicAccount: 'Vytvoriť účet',
            clubMemberBenefits: {
                title: 'Staňte sa členom Cinestar Clubu',
                benefitDiscount: 'Zľava 20 Kč na každú vstupenku',
                benefitRewards: 'Zbierajte body za vašu útratu a vyberte si odmeny zdarma.',
                benefitPoints: 'Odmena 10 bodov za registráciu.',
                feeText: 'Poplatok za členstvo je 80 Kč ročne.',
            },
            cinestarClubMember: {
                title: 'Pre dokončenie svojej registrácie CineStar klubu, prosím, ešte dopln tieto údaje',
                gender: 'Pohlavie',
                man: 'Muž',
                woman: 'Žena',
                other: 'Iné',
                dateLabel: 'Dátum narodenia',
                datePlaceholder: 'Dátum narodenia',
                dateError: 'dátum chyba',
                residenceLabel: 'Bydlisko',
                residencePlaceholder: 'Mesto',
                residenceError: 'bydlisko chyba',
                postalCodeLabel: 'PSČ',
                postalCodePlaceholder: 'PSČ',
                postalCodeError: 'PSČ chyba',
                agreement: {
                    title: 'Vaše súhlasy',
                    description:
                        'Svojím súhlasom potvrdzujem, že som sa zoznámil/a s podmienkami výrnostného programu CineStar klubu a s podmienkami spracovania osobných údajov. Osobné údaje sú spracovávané a chránené v zmysle zákona č. 101/2000 Sb. a Nariadenia o ochrane osobných údajov č. 679/2016. Súhlas so spracovaním osobných údajov pre zasielanie obchodných správ a ďalších marketingových aktivít (formou e-mailov, sms, notifikácií):',
                    checkboxLabel: 'Súhlasím so zasielaním občasných newsletterov a darčeka k narodeninám',
                    description2:
                        'Registráciou súhlasíte s našimi Všeobecnými podmienkami a Zásadami ochrany osobných údajov',
                },
                buttonBecomeMember: 'VYTVORIŤ ÚČET A STAŤ SA ČLENOM CINESTAR KLUBU',
            },
        },
        login: {
            title: 'Prihlásenie',
            orFillText: 'Alebo vyplňte',
            emailLabel: 'E-Mail',
            emailPlaceholder: 'E-Mail',
            emailError: 'Zadaný e-mail nie je platný',
            passwordLabel: 'Heslo',
            passwordPlaceholder: 'Napíšte vaše heslo',
            passwordError: 'chyba hesla',
            buttonLogin: 'PRIHLÁSIT',
            buttonForgotten: 'Zabudli ste heslo?',
            buttonCreate: 'Vytvoriť účet',
            unknownEmail: 'Nesprávny e-mail',
            wrongPassword: 'Nesprávne heslo',
            internalErrorLabel: 'Chyba',
            internalErrorText: 'Ospravedlňujeme sa, došlo k internej chybe servera. Na odstránení chyby pracujeme.',
        },
        contactInfo: {
            title: 'Kontaktné údaje',
        },
        agreements: {
            title: 'Vaše súhlasy',
            description:
                'Svojím súhlasom potvrdzujem, že som sa oboznámil/a s podmienkami vernostného programu CineStarClubu a s podmienkami spracovania osobných údajov. Osobné údaje sú spracúvané a chránené v zmysle zákona č. 101/2000 Z.z. a Nariadenia o ochrane osobných údajov č. 679/2016. Súhlas so spracovaním osobných údajov pre zasielanie obchodných správ a ďalších marketingových aktivít (formou e-mailov, sms, notifikácií):',
            nonPersonal: 'Súhlas so zasielaním neosobnej reklamy',
            personal:
                'Súhlas so zasielaním personalizovanej reklamy: aby sme Vám mohli zasielať informácie a reklamu, ktoré zodpovedajú Vašim osobným záujmom, analyzujeme Vaše zakúpené vstupenky, Vašu účasť na našich reklamných akciách a Vaše využívanie našich elektronických služieb. Pre tieto účely spracúvame nasledujúce osobné údaje: e-mail, vek, pohlavie, nákupné správanie, miesto nákupu (multikino), filmové alebo iné predstavenie, kategória filmu, čas účasti, frekvencia navštevovaných filmov, zistenie podobnosti s inými našimi zákazníkmi.',
            checkBoxNotChecked: 'Musíte zvoliť jednu z možnosti.',
        },
        lostCard: {
            title: 'Stratená karta',
            description: 'Tu môžete zablokovať vašu kartu v prípade straty alebo odcudzenia.',
            label: 'Potvrdzujem, že chcem zablokovať svoju klubovú kartu',
            checkBoxNotChecked: 'So zablokovaním karty musíte súhlasiť.',
        },
        changePassword: {
            title: 'Zmena hesla a prepojené účty',
            oldPasswordLabel: 'Staré heslo',
            oldPasswordPlaceholder: 'Zadajte svoje staré heslo',
            oldPasswordError: 'chyba starého hesla',
            newPasswordLabel: 'Nové heslo',
            newPasswordPlaceholder: 'Zadajte svoje nové heslo',
            newPasswordError: 'chyba nového hesla',
            confirmationPasswordLabel: 'Nové heslo znovu',
            confirmationPasswordPlaceholder: 'Pre kontrolu',
            confirmationPasswordError: 'chyba hesla pre kontrolu',
            invalidPassword: 'Heslo nie je platné',
            passwordMatchesEmail: 'Heslo nesmie byť rovnaké ako emailová adresa',
            passwordsMustMatch: 'Heslá sa musia zhodovať',
        },
        changeForgottenPassword: {
            title: 'Zmena hesla',
            newPasswordLabel: 'Nové heslo',
            newPasswordPlaceholder: 'Zadajte vaše heslo',
            newPasswordError: 'chyba hesla',
            confirmationPasswordLabel: 'Nové heslo znova',
            confirmationPasswordPlaceholder: 'Pre kontrolu',
            confirmationPasswordError: 'chyba hesla',
            buttonChange: 'ZMENIŤ HESLO',
            buttonCancel: 'Zrušiť',
            invalidPassword: 'Heslo nie je platné',
            passwordMatchesEmail: 'Heslo nesmie byť rovnaké ako e-mailová adresa',
            passwordsMustMatch: 'Heslá sa musia zhodovať',
            error: {
                text: 'Neboli sme schopní zmeniť heslo. Prosím skúste to znova neskôr.',
                notValid: 'Vypršela platnost odkazu',
            },
        },
        forgottenPassword: {
            title: 'Zabudnuté heslo',
            emailLabel: 'Zadajte Váš registračný e-mail.',
            emailPlaceholder: 'E-Mail',
            emailError: 'email chyba',
            buttonSend: 'POSLAŤ NOVÉ HESLO',
            buttonCancel: 'ZRUŠIŤ',
        },
        passwordValidation: {
            length: 'Musí obsahovať 8 až 16 znakov.',
            letter: 'Aspoň jedno písmeno.',
            number: 'Aspoň jednu číslice.',
            email: 'Nie je zhodné s e-mailovou adresou.',
        },
    },
    modals: {
        modalCinemaSelect: {
            title: 'Vyberte kino',
            text: 'Pre pokračovanie si prosím vyberte kino.',
        },
    },
    windows: {
        success: {
            title: 'Úspech',
            successful: 'Všetko prebehlo v poriadku.',
            contactInfo: 'Kontaktné údaje boli úspešne zmenené',
            gdpr: 'Vaše súhlasy boli úspešne zmenené',
            lostCard: 'Karta bola úspešne zablokovaná.',
            registerClub: 'Žiadosť do Cinestar Club bola úspešne odoslaná.',
            changePassword: 'Heslo bolo úspešne zmenené.',
            changeForgottenPassword: 'Vaše heslo bolo úspešne zmenené. Budete automaticky presmerovaný za 3 sekundy.',
            forgottenPassword: 'Na Váš e-mail bol odoslaný odkaz pre zmenu hesla.',
        },
        info: {
            title: 'Info',
            ticketTypes: {
                title: 'Typy lístkov',
                type: {
                    child: 'Dieťa',
                    student: 'Študent',
                    senior: 'Senior',
                    ztp: 'ZTP, ZTP/P',
                },
                description: {
                    child: 'Do 12 rokov vrátane. Dieťa do 3 rokov nemusí platiť vstupné, nemá ale nárok na vlastné sedadlo.',
                    student: 'S platným študentským preukazom do 26 rokov vrátane',
                    senior: 'Nad 60 rokov vrátane',
                    ztp: 'Sprievod ZTP/P jedna osoba zadarmo. Pre zľavu ZTP, ZTP/P je potrebné predložiť platný preukaz.',
                },
            },
        },
        notification: {
            title: 'Upozornenie',
            paidTitle: 'Zaplatené!',
            noTicketsReserv: 'Aktuálne nemáte zakúpené žiadne vstupenky ani rezervácie',
            referenceNumber: 'Referenčné číslo udalosti: {referenceNumber} (uchovajte prosím pre prípadnú reklamáciu)',
            ticketsReserved:
                'Nezabudnite si rezerváciu vyzdvihnúť v kiosku alebo na pokladne kina, aspoň 30 minút pred predstavením.',
            lights: 'Toto predstavenie obsahuje niekoľko scén v ktorých silne bliká svetlo a ktoré môžu nepriaznivo ovplyvniť divákov, ktorí trpia fotosenzitívnou epilepsiou alebo trpia zvýšenou citlivosťou na svetlo.',
            onlyCards: 'Z technických dôvodov je možné platiť iba platobnými kartami.',
            withoutPoints: 'Na toto predstavenie nie je možné využiť body z vernostného programu Cinestar Club.',
            notShared: 'Na tento film už nejde zakúpiť vstupenky online.',
            reservedTickets:
                'Rezerváciu zaplatíte na pokladni, kiosku alebo prostredníctvom mobilnej aplikácie. <bold>Vstupenky je nutné zaplatiť 30 minút pred predstavením.</bold>',
            reservationPaid: 'Túto rezerváciu už máte zaplatenú.',
        },
        loading: {
            title: 'Načítavam',
            wait: 'Počkajte chvíľu prosím.',
        },
        error: {
            title: 'Chyba',
            somethingWrong: 'Něco se pokazilo. Zkuste to znovu později.',
            E_WS_PASSWORD_CHECK_FAILED: 'Zadané heslo není správné',
            forgottenPassword: 'Nebyli jsme schopni odeslat žádost o zapomenuté heslo. Prosím zkuste to znovu později.', //TODO add right error instead of forgottenPassword
            TOKEN_EXPIRED: 'Platnost relace vypršela.',
            TOKEN_MISSING: 'Platnost relace vypršela.',
            TOKEN_FAILED: 'Platnost relace vypršela.',
            E_WS_LOGIN_EXISTS: 'Účet s tímto e-mailem již existuje.',
            CANT_READ_QR_CODE: 'Qr kód se nepodařilo načíst. Zkontrolujte, že jste nahrál správný soubor.',
            CANT_APPLY_GIFT_VOUCHER: 'Dárkový voucher nebyl rozpoznán, nebo byl již uplatněn.',
            E_API_AUTHORIZATION_FAILED: 'Chybně zadané přihlašovací údaje.',
            TICKET_UNAVAILABLE: 'Některé z označených sedadel bylo již zabráno jiným uživatelem.',
            EMAIL_TICKET_ERROR:
                'Vstupenky se nepodařilo odeslat na Váš email. Vstupenky si můžete stáhnout na této stránce nebo ve Vašem profilu. V případě potíží kontaktujte technickou podporu. ',
            CANT_LOAD_MEAL_VOUCHERS_LIST: 'Nezdařilo se načíst seznam nabídky občerstvení.',
            E_API_LOGIN_NOT_EXISTS: 'S tímto emailem není propojen žádný účet.', // Chyba pro /forgotten-password když je zadán neexistující email
            DOWNLOAD_FAIL: 'Nepodařilo se stáhnout vstupenky a vouchery.',
            API_TOKEN_MISSING: 'Platnost relace vypršela.',
            API_TOKEN_FAILED: 'Platnost relace vypršela.',
            E_API_TOKEN_NOT_FOUND: 'Platnost relace vypršela.',
            E_LP_POINTS_EXCEEDED: 'Nemáte dostatek bodů.',
            E_TICKET_FOR_VOUCHER_1_AND_1_NOT_FOUND: 'Je třeba přidat další vstupenku.',
            API_PAY_BY_POINTS_NOT_ALLOWED: 'Nelze uplatnit body.',
            API_PAY_BY_POINTS_PAYMENT_NOT_DEFINED_OR_SUPPORTED: 'Nelze uplatnit body.',
            E_API_BOOKING_CANCEL_STATE: 'Tato rezervace není aktivní.',
            E_API_BOOKING_CANCEL_DISABLED: 'Rezervaci nelze stornovat.',
            API_CART_IS_EMPTY_OR_RELEASED: 'Košík je prázdný.',
            API_CART_PAYMENT_NOT_SELECTED: 'Vyberte typ platby.',
            API_CART_PERSON_DATA_MISSING: 'Je třeba se přihlásit nebo vyplnit osobní data.',
            E_API_CARD_ALREADY_IN_CART: 'Karta je již v košíku.',
            API_REGISTRATION_PASSWORD: 'Přihlášení se nezdařilo.',
            API_REGISTRATION_EMAIL: 'Přihlášení se nezdařilo.',
            API_REGISTRATION_NAME_SURNAME: 'Přihlášení se nezdařilo.',
            API_REGISTRATION_PHONE: 'Přihlášení se nezdařilo.',
            API_CHANGE_PASSWORD_EMPTY: 'Změna hesla se nepodařila.',
            E_API_ALREADY_AUTHORIZED: 'Uživatel je již přihášen.',
            E_WS_ACCOUNT_NOT_ACTIVE: 'Přihlášení se nezdařilo.',
            E_API_CATEGORY_NOT_SHARED: 'Kategorie není povolená.',
            E_API_ACCOUNT_ALREADY_EXISTS: 'Účet již existuje.',
            API_AUTHORIZATION_FAILED: 'Přihlášení se nezdařilo.',
            API_ITEM_OCCUPIED: 'Položka již není k dispozici.',
            API_VALIDITY_EXCEEDED: 'Rezervaci již nelze vytvořit.',
            API_LOGIN_EXISTS: 'Účet již existuje.',
        },
        warning: {
            TOO_MANY_SEATS: 'Nie je možné vybrať viac ako 6 sedadiel',
            DIFFERENT_CINEMA: 'Došlo k zmene kina, váš košík bol vysypaný.',
            somethingWrong: 'Niečo sa pokazilo. Skúste to znova neskôr.',
        },
    },
    paymentVerify: {
        paymentIsBeingVerified: 'Vaša platba sa overuje',
    },
    thanksForOrder: {
        title: 'Ďakujeme za vašu objednávku',
        subtitle: 'Vstupenky sme zaslali na váš e-mail.',
        findThem: 'Nájdete ich aj vo <redirect>vašom účte</redirect>.',
        sendThem: ' Poslať vstupenky formou SMS',
    },
    ticketsReserved: {
        title: 'Vstupenky sme rezervovali',
    },
    page404: {
        pageTitle: 'Zlý smer!',
        title: 'Ospravedlňujeme sa,',
        description: '... ale táto stránka nebola nájdená.',
        button: 'Späť na hlavnú stránku',
    },
    paymentFailed: {
        pageTitle: 'Online platba sa nepodarila',
        title: 'Počas platby sa vyskytli problémy a objednávka nemohla byť uhradená.',
        description:
            'Teraz ju môžete buď zrušiť - tým sa uvoľnia vybrané sedadlá, alebo ju vrátiť do košíka a zvoliť iný druh doručenia a platby.',
        button1: 'VRÁTIŤ SA DO KOŠÍKA',
        button2: 'Zrušiť objednávku',
    },
    expiredLimit: {
        pageTitle: 'Platnosť stránky vypršala',
        title: 'Bol prekročený časový limit na dokončenie nákupu',
        description: 'Nabudúce si musíte pospíšiť.',
        button: 'SPÄŤ NA VÝBER PREDAJU',
    },
    ticket: {
        type: {
            basic: 'Základní',
            child: 'Dítě',
            student: 'Student',
            senior: 'Senior',
            ztp: 'ZTP',
            club: 'CineStar Club na 1 rok',
        },
        pointPayment: 'Uplatniť {points} bodov',
    },
    buttons: {
        yes: 'Áno',
        no: 'Nie',
        back: 'Späť',
        close: 'Zavieť',
        continue: 'POKRAČOVAŤ',
        login: 'Prihlásiť sa',
        register: 'Registrovať',
        logout: 'Odhlásiť sa',
        add: 'Pridať',
        confirm: 'POTVRDIŤ',
        confirmVoucher: 'OVERIŤ POUKAZ',
        buttonSave: 'ULOŽIŤ ZMENY',
        chooseCinema: 'Vybrať kino',
        downloadTickets: 'Stiahnuť vstupenky',
        downloadApp: 'Stiahnuť aplikáciu',
        send: 'POSLAŤ',
        apply: 'UPLATNIŤ',
        extendMembership: 'Prodloužit <span>členstvo</span>',
        orderMembership: 'Objednať členstvo online',
        social: 'Pokračovať s <spanCapitalize>{variant}</spanCapitalize>',
        goToAccount: 'Prejsť na účet',
        moreInfo: 'Viac informácií',
        payReservation: 'Zaplatiť rezerváciu',
        cancelReservation: 'Zrušiť rezerváciu',
        downloadReservation: 'Stiahnuť rezerváciu',
        toggle: {
            label: {
                basic: 'Základné',
                child: 'Dieťa',
                študent: 'Študent',
                senior: 'Senior',
                stp: 'ZŤP',
                Dítě: 'Dieťa',
                Senior: 'Senior',
                Student: 'Študent',
                ZTP: 'ZŤP',
                'CineStar Club': 'CineStar Club',
            },
        },
    },
    demo: {
        title: 'Demo stránka',
        typography: 'Typography component demo',
    },
    mailSender: {
        forgottenPassword: {
            subject: 'Cinestar - Zabudnuté heslo',
            content: 'Pre zmenu hesla kliknite na odkaz:',
        },
    },
    footer: {
        copyright: {
            advertising: 'Exkluzívnym predajcom reklamy je agentúra Cinexpress',
            regulations: 'Návštevnícky poriadok',
            terms: 'Podmienky spracovania osobných údajov',
            conditions: 'Všeobecné obchodné podmienky',
            cinestar: 'CineStar s.r.o. © {year}',
            designBy: 'Design od spoločnosti Symbio',
        },
    },
}
